module.exports = __webpack_public_path__ + "assets/plug_off.05d029a3.svg";